module.exports = __webpack_public_path__ + "static/router@3x-4131b4886d9a6dbb10e449fcd939c591.png";